module.exports = __webpack_public_path__ + "static/buyer-place-order-d1fd89a789c79beb6ee339444801f425.gif";